import React, { useEffect, useState } from 'react';
import Lottie from 'lottie-react';
import { useBrandConfig } from '@/features/brandDemo/BrandConfigContext.jsx';

/**
 * Affiche le logo de la marque.
 * - Si `brand.logoLottieUrl` est défini → charge et joue l'animation Lottie.
 * - Sinon → affiche `brand.logoUrl` comme <img>.
 *
 * @param {string} className  Classes Tailwind appliquées au conteneur (ex: "h-7 object-contain")
 */
export function BrandLogo({ className = "h-10 object-contain" }) {
    const { brand } = useBrandConfig();
    const [animationData, setAnimationData] = useState(null);

    useEffect(() => {
        if (!brand.logoLottieUrl) return;
        fetch(brand.logoLottieUrl)
            .then((r) => r.json())
            .then(setAnimationData)
            .catch(() => setAnimationData(null));
    }, [brand.logoLottieUrl]);

    if (brand.logoLottieUrl) {
        if (!animationData) return null;
        return (
            <Lottie
                animationData={animationData}
                loop
                autoplay
                className={className}
                style={{ display: 'block' }}
            />
        );
    }

    return (
        <img
            src={brand.logoUrl}
            alt={brand.name}
            className={className}
        />
    );
}
